import { render } from "./Termo.vue?vue&type=template&id=f236802e&scoped=true"
import script from "./Termo.vue?vue&type=script&lang=js"
export * from "./Termo.vue?vue&type=script&lang=js"

import "./Termo.vue?vue&type=style&index=0&id=f236802e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f236802e"]])

export default __exports__